export interface Institution {
  id: string;
  name: string;
  iconUrl: string | null;
  logoUrl: string | null;
  types: InstitutionType[];
  flags: InstitutionFlag[];
  source: InstitutionSource;
}

export enum InstitutionType {
  Accounting = 'ACCOUNTING',
  Banking = 'BANKING',
}

export enum InstitutionSource {
  ENTRATEL = 'ENTRATEL',
  FABRICK = 'FABRICK',
  MOCK = 'MOCK',
  PAYPAL = 'PAYPAL',
  SDICOOP = 'SDICOOP',
  SHOPIFY = 'SHOPIFY',
  STRIPE = 'STRIPE',
  SWAN = 'SWAN',
  SUMUP = 'SUMUP',
  TSPAY = 'TSPAY',
  USER = 'USER',
  YAPILY = 'YAPILY',
}

export enum InstitutionFlag {
  CBI = 'CBI',
  IMPORT = 'IMPORT',
  MULTI_AUTH = 'MULTI_AUTH',
  PSU_ID = 'PSU_ID',
  PSU_CORPORATE_ID = 'PSU_CORPORATE_ID',
  TRANSACTION_DEDUP = 'TRANSACTION_DEDUP',
  TRANSACTION_DEDUP_SIMILARITY = 'TRANSACTION_DEDUP_SIMILARITY',
  TRANSACTION_HASH = 'TRANSACTION_HASH',
  TRANSACTION_NODUP = 'TRANSACTION_NODUP',
  PAYMENTS = 'PAYMENTS',
  INSTANT_PAYMENTS = 'INSTANT_PAYMENTS',
  SCHEDULED_PAYMENTS = 'SCHEDULED_PAYMENTS',
  PAYMENTS_ADDRESS = 'PAYMENTS_ADDRESS',
  PSU_IP_ADDRESS = 'PSU_IP_ADDRESS',
  BULK_PAYMENTS = 'BULK_PAYMENTS',
  NEW_SYNC_FLOW = 'NEW_SYNC_FLOW',
  TRACK_PAYMENT_STATUS = 'TRACK_PAYMENT_STATUS',
}
